import { ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import * as store from "../../framework/customStore";
import { ISessionState } from "../session/sessionState";

export class StoreUtils {
    static getSessionState(): ISessionState {
        return store.customStore.getState()?.session.state;
    }

    static getNowModifyUser(data: number = null): ModifyUser {
        const result = new ModifyUser();
        result.date = data ?? new Date().getTime();
        const sessionState = StoreUtils.getSessionState();
        if (!sessionState) return result;
        result.code = sessionState.code;
        result.name = sessionState.name;
        if (sessionState.image) {
            result.picture = "data:image/png;base64," + sessionState.image;
        }
        return result;
    }
}
